import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-081334c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "change-password"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-tips"
}, "为了您的账户安全，需要进行手机验证", -1));
const _hoisted_3 = {
  class: "test-content"
};
const _hoisted_4 = {
  class: "phone"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已绑定手机：", -1));
const _hoisted_6 = {
  class: "slideWrap"
};
const _hoisted_7 = {
  class: "verification-code"
};
import MainButton from '@/components/MainButton/MainButton.vue';
import { ref, reactive, getCurrentInstance, onMounted, watch } from 'vue';
import { sendSMSMessage, validPhoneNumCode } from '@/api/phone/phone-change';
import { getscene } from '@/api/phone/password-change';
import { useRoute, useRouter } from 'vue-router';
import { showSuccessToast } from "vant";
import { showFailToast } from "vant";
export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePhoneNumber',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const disabled = ref(true);
    const scenecode = ref('');
    const appkeycode = ref('');
    const reloadbtn = ref(false);
    const route = useRoute();
    const router = useRouter();
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    const countDownFinished = ref(false);
    const downFinished = ref(false);
    const countDown = ref(null);
    const mescode = ref(null);
    const smsCode = ref(null);
    const show = ref(false);
    const request = reactive({
      phoneNo: route.query.phoneNum,
      phoneNoHidden: route.query.phoneNumhHideen,
      channel: '99',
      smsCode: '',
      sessionId: '',
      sig: '',
      vToken: ''
    });
    watch(reloadbtn, newValue => {
      if (newValue) {
        reloadbtn.value = newValue;
      }
      console.log('reloadbtn', newValue);
    });
    //监听信息是否为空，展示按钮高亮
    watch(() => request.smsCode, newValue => {
      if (newValue !== '') {
        disabled.value = false;
      } else {
        disabled.value = true;
      }
    });
    const onCountDownfinish = () => {
      reloadbtn.value = !reloadbtn.value;
      // downFinished.value = false
      // countDownFinished.value = false
      // countDown.value.reset()
      // mescode.value.innerText = '获取验证码'
    };

    const sendCode = async () => {
      $loading.openLoading();
      const {
        channel
      } = request;
      const req = {
        channel,
        verificationSessionId: request.sessionId,
        verificationSig: request.sig,
        verificationToken: request.vToken
      };
      try {
        const {
          code,
          data,
          message
        } = await sendSMSMessage(req);
        console.log('修改手机req', req);
        if (code !== 9000) {
          $loading.closeLoading();
          onCountDownfinish();
          $alert({
            message
          });
          return;
        } else {
          //短信验证码不低于1分钟后才能倒计时
          // downFinished.value = true
          // countDownFinished.value = false
          // countDown.value.reset()
          // mescode.value.innerText = ''
          $loading.closeLoading();
          $alert({
            message: data
          });
        }
      } catch (e) {
        console.log(e);
      }
    };
    const onClickNext = async () => {
      $loading.openLoading();
      const {
        phoneNo,
        smsCode
      } = request;
      const req = {
        phoneCode: smsCode
      };
      if (!smsCode) {
        $loading.closeLoading();
        $alert({
          message: '验证码不能为空'
        });
        return;
      }
      try {
        const {
          code,
          message
        } = await validPhoneNumCode(req);
        if (code !== 9000) {
          $loading.closeLoading();
          reloadbtn.value = !reloadbtn.value; //不通过时重置滑块
          $alert({
            message
          });
          return;
        } else {
          $loading.closeLoading();
          router.push({
            path: '/changePhone'
          });
        }
      } catch (e) {
        console.log(e);
      }
    };
    const slidetosuccess = val => {
      console.log('slidetosuccess', val);
      showSuccessToast('验证成功');
      // sendCode()
      countDownFinished.value = true;
      request.sessionId = val.sessionId;
      request.sig = val.sig;
      request.vToken = val.token;
      // 滑块成功直接发验证码
      console.info('滑块成功直接发验证码', 'request', request);
      sendCode();
    };
    const slidetofail = () => {
      showFailToast('验证失败');
      reloadbtn.value = !reloadbtn.value;
    };
    const queryscene = async () => {
      const params = {
        partition: 'verification',
        key: 'sms'
      };
      const {
        code,
        message,
        data
      } = await getscene(params);
      console.log('phonequeryscene', code, message, data);
      if (code === 9000) {
        scenecode.value = data.value.scene;
        appkeycode.value = data.value.appkey;
        show.value = true;
      } else {
        showFailToast(message);
      }
    };
    onMounted(() => {
      queryscene();
    });
    return (_ctx, _cache) => {
      const _component_noCaptcha = _resolveComponent("noCaptcha");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", null, _toDisplayString(request.phoneNo), 1)]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createVNode(_component_noCaptcha, {
        id: "changePhoneNumber",
        scene: scenecode.value,
        appkey: appkeycode.value,
        onSlideSuccessCallback: slidetosuccess,
        onSlideErrorCallback: slidetofail,
        reload: reloadbtn.value
      }, null, 8, ["scene", "appkey", "reload"])], 512), [[_vShow, show.value]]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: request.smsCode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => request.smsCode = $event),
          label: "验证码",
          placeholder: "请输入验证码",
          clearable: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createVNode(MainButton, {
        disabled: disabled.value,
        onClick: onClickNext
      }, {
        default: _withCtx(() => [_createTextVNode("下一步")]),
        _: 1
      }, 8, ["disabled"])])]);
    };
  }
});